export default "__VITE_ASSET__0376dd75__"